var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "M40.106 8.19C22.526 8.19 8 22.39 8 39.87S22.53 71.8 40.106 71.8s31.862-14.45 31.862-31.93S57.695 8.19 40.106 8.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.001 48.457c-1.965 0-3.931-.687-4.914-3.286-1.475 2.059-3.589 3.187-5.998 3.187-3.587 0-5.014-2.986-5.014-6.186 0-5.099 3.402-10.737 8.948-10.737a15.8 15.8 0 0 1 5.16.834c.934.294 1.082 1.126.934 1.862l-1.032 4.66c-.197 1.028-.442 2.598-.442 3.528 0 2.347.982 3.383 2.552 3.383 3.39 0 5.898-3.923 5.898-8.433 0-6.03-3.44-11.912-13.763-11.912-9.881 0-14.404 8.578-14.404 15.688 0 7.55 3.59 13.68 13.183 13.68 1.637-.01 3.268-.19 4.867-.54 1.131-.246 1.622-.491 2.114-.491.374-.008.735.141.996.411.26.27.398.636.38 1.012 0 .586-.345 1.224-1.425 1.47-2.258.62-4.591.917-6.932.883-11.305 0-16.172-7.307-16.172-16.327 0-8.874 5.751-18.58 17.352-18.58 12.485 0 16.761 7.5 16.761 14.657-.004 5.843-3.493 11.237-9.049 11.237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "M40.923 34.385c-3.243 0-5.494 4.122-5.494 7.648 0 1.92.835 2.987 2.262 2.987 2.605 0 4.325-2.304 4.965-5.295l1.065-4.947c-.91-.26-1.852-.393-2.798-.393"
  }))));
};
export default SvgEmail;